import {
  TextFieldContainer,
  TextFieldInputContainer,
} from '../TextField/TextField.styles';
import styled from 'styled-components';
import { TrevorIcon } from '../TrevorIcon';
import React, { FC } from 'react';

export const SearchFieldContainer = styled(TextFieldInputContainer)`
  padding: var(--spacing-s) var(--spacing-m);

  > input {
    font-family: 'DM Sans', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    caret-color: var(--color-interface-secondary-normal);
  }

  > svg {
    color: var(--color-interface-secondary-normal);
  }
`;

const ClearButton = styled(TrevorIcon).attrs({ name: 'close-circle' })`
  cursor: pointer;
`;

type SearchFieldProps = {
  value?: string;
  onChange: F<string>;
  onEnter?: F<string>;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'>;

export const SearchField: FC<SearchFieldProps> = ({
  onChange,
  onEnter,
  className,
  ...props
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const hasValue = inputRef.current && inputRef.current.value;

  const handleClear = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (inputRef.current) inputRef.current.value = '';
    onChange('');
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      onEnter && onEnter(inputRef.current ? inputRef.current.value : '');
    }
  };

  return (
    <SearchFieldContainer className={className}>
      <input
        ref={inputRef}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        {...props}
      />
      {hasValue ? (
        <ClearButton onClick={handleClear} />
      ) : (
        <TrevorIcon name={'search'} />
      )}
    </SearchFieldContainer>
  );
};
